import { useSelector } from "react-redux";
import { GeoJSON } from "react-leaflet";

// Utils and Constants
import {
  geoJsonFeatureCallbacks,
  getBoundaryMarkersData,
} from "../boundaries/BoundariesUtil";
import {
  PincodeRankingBlueShades,
  PincodeRankingBoundaryType,
} from "../../../constants/GeneralConstants";

/**
 * Pincode Ranking Markers
 */
export default function PincodeRankingMarkers() {
  // ranked pincode boundaries polygon data
  const rankedBoundariesPolygonData = useSelector(
    (state) => state.region.rankedBoundariesPolygonData
  );

  // polygon data for pincode ranking
  const polygonData = {
    pincode: rankedBoundariesPolygonData,
  };

  // getting Boundary Markers Data
  const { polygonFeatures } = getBoundaryMarkersData(
    polygonData,
    PincodeRankingBoundaryType
  );

  const totalFeatures = polygonFeatures.length;
  const totalShades = PincodeRankingBlueShades.length;

  // Add each Region
  const geoJsonLayers = polygonFeatures.map((ft, index) => {
    // Properties
    const ftProps = ft.properties || {};

    // data
    const { alias, name } = ftProps || {};
    const rank = index + 1;
    const pincodeName = alias || name || "";

    // shade index
    const shadeIndex = Math.min(
      totalShades - 1,
      Math.floor((index * totalShades) / totalFeatures)
    );

    // Feature Style
    const ftStyle = {
      weight: 1,
      opacity: 1,
      color: "blue",
      dashArray: "1",
      fillColor: PincodeRankingBlueShades[shadeIndex],
      fillOpacity: 0.8,
    };

    function onEachFeature(feature, layer) {
      geoJsonFeatureCallbacks(feature, layer);

      layer.bindTooltip(`<strong>Rank ${rank}</strong> : ${pincodeName}`, {
        permanent: true,
        direction: "top",
        className: "pincode-ranking-tooltip",
      });
    }

    return (
      <>
        <GeoJSON
          key={ftProps.id}
          data={ft}
          style={ftStyle}
          onEachFeature={onEachFeature}
        />
      </>
    );
  });

  return geoJsonLayers;
}
